import { render, staticRenderFns } from "./Perfil.vue?vue&type=template&id=0f425b3b&scoped=true"
import script from "./Perfil.vue?vue&type=script&lang=ts"
export * from "./Perfil.vue?vue&type=script&lang=ts"
import style0 from "./Perfil.vue?vue&type=style&index=0&id=0f425b3b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f425b3b",
  null
  
)

export default component.exports